import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { DocumentsService } from "src/app/services/documents.service";

/**
 * Because the url may become very long if we download many files we may exceed the
 * maximum url length in some browsers (in IE the limit is 2083 characters).
 *
 * This is the reason why we have to do a Form POST.
 *
 * This component can dynamically build a HTML form hidden fields which contain the document ids.
 * The only visible element is a button that will submit the form (via the browser).
 */
@Component({
  selector: "lh-docs-zip-download",
  template: ` <form method="POST" [action]="targetUrl" ngNoForm #invisibleForm>
    <input
      *ngFor="let documentId of documentIds"
      type="hidden"
      name="documentId"
      [value]="documentId"
    />

    <patternlib-button
      size="small"
      [disabled]="documentIds.length === 0"
      (click)="this.onDownloadClick()"
    >
      {{ "button_download_zip" | translate }}
    </patternlib-button>
  </form>`,
})
export class DocsZipDownloadComponent implements OnInit {
  @Input() documentIds: string[] = [];
  targetUrl: string | null = null;

  @ViewChild("invisibleForm")
  invisibleForm!: ElementRef<HTMLFormElement>;

  constructor(private docService: DocumentsService) {}

  ngOnInit(): void {
    this.docService
      .getDownloadEndpointUrl()
      .then((url) => (this.targetUrl = url));
  }

  onDownloadClick() {
    this.invisibleForm.nativeElement.submit();
  }
}
